// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"Modal_CloseButton__aL4Xa","BackButton":"Modal_BackButton__SslKD","Page":"Modal_Page__qarxq","Active":"Modal_Active__1q9Jw"};